import uuidv4 from 'uuid/v4';
import {
  FolderSpecial,
  Business,
  ShoppingBasket,
  PieChartIcon,
  Dashboard,
  Notifications,
  PeopleAlt,
  Bed,
} from 'utilsModule/material-ui-icons';
import {
  OrganisationsIcon,
  SurveyIcon,
  ProvidersIcon,
  CareTeamsIcon,
  ChargeCodesIcon,
  InventoryIcon,
  InvoiceIcon,
  QuestionnaireIcon
} from 'utilsModule/customIcons';
import i18n from 'appModule/i18n';

export function getSuperAdminMenu() {
  return [
    {
      id: uuidv4(),
      icon: <OrganisationsIcon />,
      label: i18n.t('common:sideMenu.organisation'),
      path: 'orgs',
    },
    {
      id: uuidv4(),
      icon: <ChargeCodesIcon />,
      label: i18n.t('common:sideMenu.chargeCode'),
      path: 'chargecode',
    },
    {
      id: uuidv4(),
      icon: <InventoryIcon />,
      label: i18n.t('common:sideMenu.inventory'),
      path: 'inventory',
    },
    {
      id: uuidv4(),
      icon: <InvoiceIcon />,
      label: i18n.t('common:sideMenu.invoices'),
      path: 'orgsInvoices',
    },
    {
      id: uuidv4(),
      icon: <SurveyIcon />,
      label: i18n.t('common:sideMenu.survey'),
      path: 'feedback',
    },
  ];
}

export function getClusterAdminMenu() {
  return [
    {
      id: uuidv4(),
      icon: <OrganisationsIcon />,
      label: i18n.t('common:sideMenu.organisation'),
      path: 'orgs',
      resource: 'ORGANISATION',
    },
  ];
}

export function getGroupAdminMenu() {
  return [
    {
      id: uuidv4(),
      icon: <OrganisationsIcon />,
      label: i18n.t('common:sideMenu.organisation'),
      path: 'orgs',
      resource: 'ORGANISATION',
    },
  ];
}

export function getHospitalAdminMenu() {
  return [
    {
      id: uuidv4(),
      icon: <ProvidersIcon />,
      label: i18n.t('common:sideMenu.providers'),
      path: 'providers',
      resource: 'PROVIDER',
    },
    {
      id: uuidv4(),
      icon: <CareTeamsIcon />,
      label: i18n.t('common:sideMenu.careTeams'),
      path: 'careteams',
      resource: 'CARE_TEAM',
    },
    {
      id: uuidv4(),
      icon: <FolderSpecial />,
      label: i18n.t('common:sideMenu.programmes'),
      path: 'programs',
      resource: 'ADMIN_PROGRAMME',
    },
    {
      id: uuidv4(),
      icon: <ChargeCodesIcon />,
      label: i18n.t('common:sideMenu.chargeCode'),
      path: 'chargecode',
      resource: 'CHARGE_CODE',
    },
    {
      id: uuidv4(),
      icon: <ShoppingBasket />,
      label: i18n.t('common:sideMenu.consumables'),
      path: 'consumables',
      resource: 'CONSUMABLE',
    },
    {
      id: uuidv4(),
      icon: <InventoryIcon />,
      label: i18n.t('common:sideMenu.inventory'),
      path: 'inventory',
      resource: 'INVENTORY',
    },
    {
      id: uuidv4(),
      icon: <InvoiceIcon />,
      label: i18n.t('common:sideMenu.invoices'),
      path: 'invoices',
      resource: 'INVOICE',
    },
    {
      id: uuidv4(),
      icon: <QuestionnaireIcon />,
      label: i18n.t('common:sideMenu.questionnaires'),
      path: 'questionnaires',
      resource: 'QUESTIONNAIRE_TEMPLATE',
    },
    {
      id: uuidv4(),
      icon: <FolderSpecial />,
      label: i18n.t('common:sideMenu.kiosk'),
      path: 'kiosk',
      resource: 'KIOSK',
    },
  ];
}

export function getProviderMenu() {
  return [
    {
      id: uuidv4(),
      icon: <Dashboard />,
      label: i18n.t('common:sideMenu.dashboard'),
      path: 'dashboard',
      resource: 'DASHBOARD',
    },
    {
      id: uuidv4(),
      icon: <Notifications />,
      label: i18n.t('common:sideMenu.alerts'),
      path: 'alerts',
      resource: 'ALERT',
    },
    {
      id: uuidv4(),
      icon: <PeopleAlt />,
      label: i18n.t('common:sideMenu.participants'),
      path: 'participants',
      resource: 'PARTICIPANT',
    },
    {
      id: uuidv4(),
      icon: <FolderSpecial />,
      label: i18n.t('common:sideMenu.programmes'),
      path: 'programs',
      resource: 'ADMIN_PROGRAMME',
    },
    {
      id: uuidv4(),
      icon: <ShoppingBasket />,
      label: i18n.t('common:sideMenu.consumables'),
      path: 'consumables',
      resource: 'CONSUMABLE',
    },
    {
      id: uuidv4(),
      icon: <InventoryIcon />,
      label: i18n.t('common:sideMenu.inventory'),
      path: 'inventory',
      resource: 'INVENTORY',
    },
    {
      id: uuidv4(),
      icon: <FolderSpecial />,
      label: i18n.t('common:sideMenu.kiosk'),
      path: 'kiosk',
      resource: 'KIOSK',
    },
    {
      id: uuidv4(),
      icon: <Business />,
      label: i18n.t('common:sideMenu.adherenceReport'),
      path: 'adherence-report',
      resource: 'ADHERENCE_REPORT',
    },
    {
      id: uuidv4(),
      icon: <PieChartIcon />,
      label: i18n.t('common:sideMenu.reports'),
      path: 'reporting',
      resource: 'PARTICIPANT',
    },
    /* MONIT is gated by the group organisation's isMonitEnabled flag rather than
       by the SIDEBAR ui-permission set, so Sidebar.js both appends this entry
       conditionally and exempts its path from the ACL filter. */
    {
      id: uuidv4(),
      icon: <Bed />,
      label: i18n.t('common:sideMenu.monitDashboard'),
      path: 'monit-dashboard',
      resource: 'MONIT_DASHBOARD',
    },
  ];
}

const participantTabList = [
  {
    id: 'care plans',
    value: 'careplans',
    operation: 'VIEW_PROGRAMME',
    path: 'careplans',
    label: 'participants.participantDetails.tabs.carePlans',
  },
  {
    id: 'care tasks',
    value: 'caretask',
    operation: 'VIEW_CARE_TASK',
    path: 'caretask',
    label: 'participants.participantDetails.tabs.careTasks',
  },
  {
    id: 'results',
    value: 'results',
    operation: 'VIEW_VITAL',
    path: 'results',
    label: 'participants.participantDetails.tabs.results',
  },
  {
    id: 'alerts',
    value: 'alerts',
    operation: 'VIEW_ALERT',
    path: 'alerts',
    label: 'participants.participantDetails.tabs.alerts',
  },
  {
    id: 'adherence',
    value: 'adherence',
    operation: 'VIEW_PROGRAMME',
    path: 'profile',
    label: 'participants.participantDetails.tabs.adherence',
  },
  {
    id: 'reporting',
    value: 'reporting',
    operation: 'VIEW_PROGRAMME',
    path: 'reporting',
    label: 'participants.participantDetails.tabs.reporting',
  },
  {
    id: 'devices',
    value: 'devices',
    operation: 'VIEW_DEVICE',
    path: 'devices',
    label: 'participants.participantDetails.tabs.devices',
  },
  {
    id: 'contract',
    value: 'contract',
    operation: 'VIEW_DEVICE',
    path: 'contract',
    label: 'participants.participantDetails.tabs.contract',
  },
  {
    id: 'profile',
    value: 'profile',
    operation: 'VIEW_PROFILE',
    path: 'profile',
    label: 'participants.participantDetails.tabs.profile',
  },
];

export default {
  participantTabList,
};
